const mainButtons = document.querySelectorAll('.full-page-modal-main-button');
const childContainers = document.querySelectorAll('.full-page-modal-buttons-children-container');

if(mainButtons.length > 0 && childContainers.length > 0) {

	hideAll();

	mainButtons.forEach((button) => {
		button.addEventListener('click', (event) => {
			mainButtons.forEach((button) => {
				button.classList.remove('button-active');
			});
			event.target.classList.add('button-active');
			showButtons(event.target.dataset.modalId);
		});
	});

}

function hideAll() {
	childContainers.forEach((container) => {
		container.classList.remove('container-visible');
	});
}

function showButtons(termId) {
	hideAll();
	childContainers.forEach((container) => {
		if(container.dataset.mainTermId === termId) {
			container.classList.add('container-visible');
		}
	});
}